export default {
  fastEase: '.15s ease',
  mdEase: '.25s ease',
  slowEase: '.35s ease',
  duration: '.15s',
  effect: 'ease',
};
